export const BLOBS = [
  ['orangeBlob', 'orange-blob-warp'],
  ['purpleBlob', 'purple-blob-warp'],
  ['blueBlob', 'blue-blob-warp'],
  ['greenBlob', 'green-blob-warp'],
] as const;
